import {
  KNOWLEDGE_STATUSES,
  KNOWLEDGE_VISIBILITIES,
  type KnowledgeStatus,
  type KnowledgeVisibility,
} from '@/shared/api/knowledge';

/** `validateSearch` of `/knowledge` (`AM-132 point 11`): the search box and every filter live in the URL. */
export interface KnowledgeListSearch {
  q?: string;
  status?: KnowledgeStatus;
  visibility?: KnowledgeVisibility;
  categoryId?: string;
}

export function knowledgeListSearchSchema(search: Record<string, unknown>): KnowledgeListSearch {
  const result: KnowledgeListSearch = {};

  const q = search['q'];
  if (typeof q === 'string' && q.trim().length > 0) {
    result.q = q;
  }

  const status = search['status'];
  if (typeof status === 'string' && KNOWLEDGE_STATUSES.includes(status as KnowledgeStatus)) {
    result.status = status as KnowledgeStatus;
  }

  const visibility = search['visibility'];
  if (
    typeof visibility === 'string' &&
    KNOWLEDGE_VISIBILITIES.includes(visibility as KnowledgeVisibility)
  ) {
    result.visibility = visibility as KnowledgeVisibility;
  }

  const categoryId = search['categoryId'];
  if (typeof categoryId === 'string' && categoryId.trim().length > 0) {
    result.categoryId = categoryId;
  }

  return result;
}
